import * as yup from 'yup';
import { SolarFarmSchema } from '../../schemas/SolarFarmSchema';

export const SolarFarmSearchResultSchema = yup.object({
  id: yup.number().defined(),
  uuid: yup.string().defined(),
  name: yup.string().defined(),
  org_id: yup.number().defined(),
  created_tsecs: yup.number().defined(),
  updated_tsecs: yup.number().nullable(),
  latitude: yup.number().defined(),
  longitude: yup.number().defined(),
  solar_module_id: yup.number().nullable(),
  address: yup.string().nullable(),
  module_layout: yup.string().nullable(),
  module_mount: yup.string().nullable(),
  commissioning_tsecs: yup.number().nullable(),
  size: yup.number().nullable(),
  access_code: yup.string().nullable(),
  ppa_rate: yup.number().nullable(),
  country: yup.string().nullable(),
  state: yup.string().nullable(),
  asset_id: yup.string().nullable(),
  creator_id: yup.number().defined(),
  client_org_id: yup.number().defined(),
  status: yup.number().defined(),
  site_layout: yup.string().nullable(),
  source_farm_uuid: yup.string().uuid().nullable(),
  row_child_process_status: yup.string().nullable(),
  site_status: yup.string().nullable(),
  peak_sunlight_hours_annual: yup.number().nullable(),
  ac_size_megawatts: yup.number().nullable(),
});
export type SolarFarmSearchResult = yup.InferType<
  typeof SolarFarmSearchResultSchema
>;

export const SolarFarmSearchResponseSchema = yup.object({
  solar_farms: yup.array(SolarFarmSearchResultSchema.defined()).defined(),
});
export type SolarFarmSearchResponse = yup.InferType<
  typeof SolarFarmSearchResponseSchema
>;

export const GetSolarFarmByUuidResponseSchema = yup.object({
  solar_farm: SolarFarmSchema.defined(),
});

export type GetSolarFarmByUuidResponse = yup.InferType<
  typeof GetSolarFarmByUuidResponseSchema
>;

export const UpdateSolarFarmResponseSchema = yup.object().unknown(true);

export type UpdateSolarFarmPayload = {
  name?: string | null;
  address?: string | null;
  country?: string | null;
  state?: string | null;
  latitude?: number | null;
  longitude?: number | null;
  size?: number | null;
  access_code?: string | null;
  ppa_rate?: number | null;
  asset_id?: string | null;
  module_layout?: string | null;
  module_mount?: string | null;
  site_layout?: string | null;
  status?: number | null;
  solar_module_id?: number | null;
  client_org_id?: number | null;
  commissioning_tsecs?: number | null;
  peak_sunlight_hours_annual?: number | null;
  partner?: string | null;
  partner_key?: string | null;
};
